(function () {
  var ZONE = 'America/Chicago';
  var CUTOFF_HOUR = 13;
  var WEEKDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var DAY_NAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function chicagoParts(date) {
    var map = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: ZONE,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .forEach(function (part) {
        if (part.type !== 'literal') map[part.type] = part.value;
      });
    return {
      weekday: WEEKDAY[map.weekday],
      hour: Number(map.hour),
      minute: Number(map.minute),
    };
  }

  function formatRemain(totalMins) {
    if (totalMins < 1) return 'under 1m';
    if (totalMins < 60) return totalMins + 'm';
    var hours = Math.floor(totalMins / 60);
    var mins = totalMins % 60;
    if (hours >= 48) {
      var days = Math.floor(hours / 24);
      var rest = hours % 24;
      return rest ? days + 'd ' + rest + 'h' : days + 'd';
    }
    return mins ? hours + 'h ' + mins + 'm' : hours + 'h';
  }

  function etaCopy(now) {
    var chicago = chicagoParts(now);
    var nowMins = chicago.hour * 60 + chicago.minute;
    var cutoffMins = CUTOFF_HOUR * 60;
    var daysAhead = 0;
    var pickupWeekday = chicago.weekday;

    if (!(chicago.weekday >= 1 && chicago.weekday <= 5 && nowMins < cutoffMins)) {
      daysAhead = 1;
      pickupWeekday = (chicago.weekday + 1) % 7;
      while (pickupWeekday === 0 || pickupWeekday === 6) {
        daysAhead += 1;
        pickupWeekday = (pickupWeekday + 1) % 7;
      }
    }

    var remain = daysAhead * 24 * 60 + (cutoffMins - nowMins);
    var when = daysAhead === 0 ? 'today' : daysAhead === 1 ? 'tomorrow' : DAY_NAME[pickupWeekday];
    var by = daysAhead === 0 ? '1pm' : daysAhead === 1 ? '1pm tomorrow' : '1pm ' + DAY_NAME[pickupWeekday];
    return 'Order by ' + by + ' — pick up ' + when + ' in ' + formatRemain(remain);
  }

  function syncEta() {
    if (!document.querySelector('[data-pj-eta-text]')) return;
    var text = etaCopy(new Date());
    document.querySelectorAll('[data-pj-eta-text]').forEach(function (el) {
      el.textContent = text;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncEta);
  } else {
    syncEta();
  }

  document.addEventListener('shopify:section:load', syncEta);
  window.setInterval(syncEta, 15000);
})();
